import { useEffect } from 'react';
import { useMapStore } from 'src/stores';

export function RouteLayer({ onMarkerClick, showRoutes }) {
    const { mapInstance } = useMapStore();

    useEffect(() => {
        if (!mapInstance) return;
        const map = mapInstance;

        const loadRoutes = async () => {
            // Load custom icon
            if (!map.hasImage('scenic-drive')) {
                await new Promise((resolve) => {
                    map.loadImage('/icons/scenic-drive.png', (error, image) => {
                        if (!error && image) {
                        map.addImage('scenic-drive', image);
                        }
                        resolve();
                    });
                });
            }

            // Load GeoJSON
            const res = await fetch('/map-routes.json');
            const data = await res.json();

            // Add source
            if (!map.getSource('panam-routes')) {
                map.addSource('panam-routes', {
                    type: 'geojson',
                    data,
                });
            }

            // Clickable invisible overlay line (wider for easier clicks)
            if (!map.getLayer('panam-routes-clickable')) {
            map.addLayer({
                id: 'panam-routes-clickable',
                type: 'line',
                source: 'panam-routes',
                layout: {
                'line-join': 'round',
                'line-cap': 'round',
                },
                paint: {
                'line-color': '#000000',  // Invisible
                'line-width': 20,         // Wide hitbox (adjust 15-30 for mobile/desktop feel)
                'line-opacity': 0,
                },
            });
            }

            // Visible styled line (on bottom)
            if (!map.getLayer('panam-routes-lines')) {
            map.addLayer({
                id: 'panam-routes-lines',
                type: 'line',
                source: 'panam-routes',
                layout: {
                    'line-join': 'round',
                    'line-cap': 'round',
                },
                paint: {
                    'line-color': ['get', 'color'],
                    'line-width': 3,
                    'line-opacity': 0.8,
                    'line-dasharray': [1, 1],
                },
            });
            }

            map.on('click', 'panam-routes-clickable', (e) => {
                const feature = e.features[0];
                const props = feature.properties;

                let parsedImages = [];
                try {
                    parsedImages = typeof props.images === 'string' ? JSON.parse(props.images) : props.images || [];
                } catch {}

                onMarkerClick({
                    id: props.id,
                    title: props.title,
                    description: props.description || '',
                    coords: props.center,
                    category: props.category,
                    googleMapsUrl: props.googleMapsUrl,
                    country: props.country,
                    images: parsedImages,
                });
            });

            map.on('mouseenter', 'panam-routes-clickable', () => map.getCanvas().style.cursor = 'pointer');
            map.on('mouseleave', 'panam-routes-clickable', () => map.getCanvas().style.cursor = '');
        };

        // Load if style ready, else on load
        if (map.isStyleLoaded()) {
            loadRoutes();
        } else {
            map.once('load', loadRoutes);
        }

        // Cleanup (optional, as layers persist like your POIs)
        return () => {
        // If needed: map.removeLayer/removeSource for 'panam-routes-*'
        };
    }, [mapInstance, onMarkerClick]);

    // Dynamic toggle (no reload)
    useEffect(() => {
        if (!mapInstance) return;
        const visibility = showRoutes ? 'visible' : 'none';
        ['panam-routes-lines', 'panam-routes-symbols'].forEach((layerId) => {
            if (mapInstance.getLayer(layerId)) {
                mapInstance.setLayoutProperty(layerId, 'visibility', visibility);
            }
        });
    }, [showRoutes, mapInstance]);

    return null;
}